import { createContext } from 'react'

import { initialAppContext } from '../utils'

const AppContext = createContext(initialAppContext)

export { AppContext }
